<mat-tab-group xmlns="http://www.w3.org/1999/html">
  <mat-tab>
    <ng-template mat-tab-label>
      <div>{{ 'verification.id.label' | translate }}</div>

    </ng-template>
    <itfg-data-table
      [data]="updatedIdVerificationData"
      [columns]="idVerificationColumns"
      >
      <ng-template itfgDataTableTemplate="actions" let-verification="row">
          <div>
            <button mat-icon-button (click)="redirectToCredit(verification)" matTooltip="{{ 'global.openLatestCredit' | translate }}">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </div>
      </ng-template>
      
      <ng-template itfgDataTableTemplate="status"
        let-value="value">
        <span>
          {{ 'verification.id.status.' + value | translate }}
        </span>
      </ng-template>
      
      <ng-template itfgDataTableTemplate="flow"
        let-value="value">
        <span>
          {{ 'verification.id.flow.' + value | translate }}
        </span>
      </ng-template>

      <ng-template itfgDataTableTemplate="idFrontStatus"
        let-value="value">
        <span *ngIf="value">
          {{ 'verification.id.documentStatus.' + value | translate }}
        </span>
      </ng-template>
      
      <ng-template itfgDataTableTemplate="idBackStatus"
        let-value="value">
        <span *ngIf="value">
          {{ 'verification.id.documentStatus.' + value | translate }}
        </span>
      </ng-template>
      
      <ng-template itfgDataTableTemplate="selfieStatus"
        let-value="value">
        <span *ngIf="value">
          {{ 'verification.id.documentStatus.' + value | translate }}
        </span>
      </ng-template>

      <ng-template itfgDataTableTemplate="startedAt"
        let-startedAt="value">
        <itfg-date-format [date]="startedAt"
        [fullDate]="true"></itfg-date-format>
      </ng-template>
    </itfg-data-table>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <div>{{ 'verification.bankAccounts' | translate }}@if (bankAccountsDataNewIds.length > 0) {
        <span matBadge="!"></span>
      }</div>
    </ng-template>
    <itfg-data-table [data]="updatedBankAccountsVerificationData"
      [columns]="bankAccColumns">
      <ng-template itfgDataTableTemplate="id" let-value="value">
        <a [routerLink]="['/credits', value]" target="_blank">{{ value }}</a>
      </ng-template>
      <ng-template itfgDataTableTemplate="creditStatus"
        let-status="value">
        <itfg-credit-status-icon [creditStatus]="status" [showName]="true"></itfg-credit-status-icon>
      </ng-template>
      <ng-template itfgDataTableTemplate="user"
        let-value="value"
        let-row="row"
        let-column="column">
        <span [ngClass]="{'change-grey': bankAccountsDataMissingIds.includes(row.id), 'change-bold': bankAccountsDataNewIds.includes(row.id) }">
          {{ value | clientFullName }}
        </span>
      </ng-template>
      <ng-template itfgDataTableTemplate="tags"
        let-tags="value">
        <itfg-tags-table-cell-view [tags]="tags"></itfg-tags-table-cell-view>
      </ng-template>
      <ng-template itfgDataTableTemplate="createTime"
        let-createTime="value">
        <itfg-date-format [date]="createTime"
        [fullDate]="true"></itfg-date-format>
      </ng-template>
      <ng-template itfgDataTableTemplate="operator"
        let-value="value"
        let-row="row"
        let-column="column">
        {{ value | administratorFullName }}
      </ng-template>
    </itfg-data-table>
  </mat-tab>
</mat-tab-group>
